import * as React from "react";
import PropTypes from 'prop-types';

const CustomLabelInput = ({ label }) => {
    return ( <h6 className="px-2 mb-5 align-self-center small" style={{ backgroundColor: 'white' }}>{label}</h6> );
}

CustomLabelInput.propTypes = {
    label: PropTypes.string,
};

export default CustomLabelInput;